import axios from "axios";

const baseURL = process.env.REACT_APP_BACKEND_URL || "";

export const api = axios.create({
    baseURL,
    withCredentials: true,
    headers: { "Content-Type": "application/json" },
});

export function formatApiError(err) {
    const data = err?.response?.data;
    // FastAPI HTTPException returns {"detail": "message"}
    const d = data?.detail;
    if (d != null) {
        if (typeof d === "string") return d;
        if (Array.isArray(d))
            return d.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" • ");
        if (typeof d.msg === "string") return d.msg;
        return JSON.stringify(d);
    }
    // Plain string response (e.g. HTML error page)
    if (typeof data === "string" && data.length > 0) {
        return data.slice(0, 500);
    }
    return err?.message || "Request failed";
}
